export enum SupportedGeocoderCountry {
    US = "US"
};

export const getCountryFromGeocodeResult = (result: google.maps.GeocoderResult): string => {
    if (result
        && result.address_components
        && result.address_components.length > 0) {
        for (const component of result.address_components) {
            if (component.types.indexOf("country") > -1) {
                return component.short_name;
            }
        }
    }
    return null;
};

export const getFirstGeocodeResult = (results: google.maps.GeocoderResult[], country: SupportedGeocoderCountry = null): google.maps.GeocoderResult => {
    if (results && results.length > 0) {
        if (country) {
            for (const result of results) {
                if (country === getCountryFromGeocodeResult(result)) {
                    return result;
                }
            }
        } else {
            return results[0];
        }
    }
    return null;
};